export default "__VITE_ASSET__BhhsneUY__"